import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { GazetteService } from '../data/gazette.service';
import { AuthWebService } from 'app/services/authweb.service';

@Component({
  selector: 'app-select-applications',
  templateUrl: './select-applications.component.html',
  styleUrls: ['./select-applications.component.scss']
})
export class SelectApplicationsComponent implements OnInit {
  public apps
  all_selected_values: string[] = [];
  reg_event_id = 0;
  isLoading = false;
  back = '/select/gazettes/'

  constructor(private router:Router,private service:GazetteService,private activeRoute: ActivatedRoute,public authentication: AuthWebService) { }

  ngOnInit(): void {
    this.getApps();
    this.activeRoute.params.subscribe((params: Params) => {
      this.reg_event_id =  params['id'];
      
    });
    
  }
returnSelectApplication(){
  if(this.all_selected_values.length == 0){
    if(this.router.url.includes('select/gazettes/application')){
      return  this.router.navigateByUrl('/list/gazettes');
    }
  return  this.router.navigateByUrl('/view/edit/gazettes/'+this.reg_event_id);
  }
  let name = this.authentication.userData.User.FirstName+' '+this.authentication.userData.User.LastName;
  this.isLoading = true;
  this.service.saveSelected(this.all_selected_values,this.reg_event_id,name).subscribe(x => {
    this.isLoading = false;
    this.router.navigateByUrl('/view/edit/gazettes/'+this.reg_event_id)
  })
}
getApps(){
  this.isLoading = true;
  this.service.getApplications().subscribe((x:any) => {
    console.log(x.Items)
    this.apps = x.Items;
    this.isLoading = false;
  })
}
onChange(value: string): void {
  console.log(value)
  if (this.all_selected_values.includes(value)) {
    this.all_selected_values = this.all_selected_values.filter(
      (item) => item !== value
    );
  } else {
    this.all_selected_values.push(value);
  }
}
}
